import React, { useMemo } from "react";

import { Row, Col } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Button from "shared/components/Button";
import { NAME_SPACES } from "shared/locals/constants";

import Contact from "./Contact";
import Notification from "./Notification";
import Warnings from "./Warnings";
import "./styles.scss";
import Space from "../../../shared/components/Space";
import {PrivacyPolicyLink} from "../../../shared/components/PrivacyPolicyLink";

const Component = ({
  loading,
  values,
  onChange,
  civilitiesQuery,
  countriesQuery,
  onSubmit,
  error,
}) => {
  const { t } = useTranslation(NAME_SPACES.ACCOUNT);
  const isDisabled = useMemo(
    () =>
      !values.name ||
      !values.firstname ||
      !values.address1 ||
      !values.postCode ||
      !values.town ||
      !values.countryCode ||
      !values.cellPhone,
    [values],
  );


  const privacyPolicyElt = useMemo(()=>{
    const textChunks = t("CONTACT.PRIVACY_POLICY", {"PRIVACY_POLICY_LINK": "__BREAK_POLICY_LINK__"}).split("__BREAK_POLICY_LINK__");

    if(textChunks.length===2){
      return <p style={{whiteSpace: "pre-wrap"}}>
        {textChunks[0]}<PrivacyPolicyLink/>{textChunks[1]}
      </p>
    }else{
      return <p style={{whiteSpace: "pre-wrap"}}>textChunks[0]</p>;
    }
  }, [t]);

  return (
    <>
      <Row gutter={16} className={"account-wrapper"}>
        <Col sm={24}>
          <Warnings values={values} error={error} />
        </Col>
        <Col sm={24}>
          <Contact
            values={values}
            error={error}
            onChange={onChange}
            civilitiesQuery={civilitiesQuery}
            countriesQuery={countriesQuery}
          />
          <Notification values={values} onChange={onChange} />
          {privacyPolicyElt}
          <Space h={24} />
        </Col>
        <Col sm={24}>
          <Button
            disabled={isDisabled}
            loading={loading}
            text={t("SAVE")}
            variant={"SECONDARY"}
            onClick={onSubmit}
          />
        </Col>
      </Row>
    </>
  );
};

Component.propTypes = {
  loading: PropTypes.bool.isRequired,
  civilitiesQuery: PropTypes.shape({
    data: PropTypes.array,
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  countriesQuery: PropTypes.shape({
    data: PropTypes.array,
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  values: PropTypes.shape({
    civilityCode: PropTypes.string,
    firstname: PropTypes.string,
    name: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    town: PropTypes.string,
    postCode: PropTypes.string,
    country: PropTypes.string,
    email: PropTypes.string,
    cellPhone: PropTypes.string,
    languageCode: PropTypes.string,
    loginEmail: PropTypes.string,
    password: PropTypes.string,
    fidelity: PropTypes.string,
    countryCode: PropTypes.string,
    dataList: PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
    visible: PropTypes.bool,
    geolocalized: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.shape({
    statusCode: PropTypes.number.isRequired,
  }),
};

Component.defaultProps = {};

export default Component;
